import { createAction } from '@reduxjs/toolkit';

const toggleCall = createAction('callToggle/toggleCall');
export default toggleCall;
